// React Imports
import React from 'react';

// Mui Imports
import {Avatar, Tooltip} from '@mui/material';
import {GRID_DETAIL_PANEL_TOGGLE_FIELD} from "@mui/x-data-grid-pro";
import {deepOrange, green} from "@mui/material/colors";

// App Imports
import WorkIssuanceStatusMenu from "../Status/WorkIssuanceStatusMenu";


// main function
export const WorkIssuanceOwedGridColumns = ({ hideActions, contracts, handleMousedRow, cashState, accrualState, liabilityState, ultimatesState, handleClickedRow }) =>

    // ***************** BEGIN COLUMNS ***************************

    [
    {
        field: 'id',
        headerName: 'id',
        description: '',
        sortable: true,
        editable: true,
        width: 60,
        hide: true
    },

    {
        field: 'reuseMarket',
        headerName: 'Reuse Market',
        description: '',
        sortable: false,
        editable: true,
        width: 250,

    },
    //
    {
        field: 'cdpId',
        headerName: 'cdpId',
        description: '',
        sortable: false,
        editable: true,
        width: 60,
        hide: true
    },
    {
        field: 'dataPointId',
        headerName: 'dataPointId',
        description: '',
        sortable: false,
        editable: true,
        width: 60,
        hide: true
    },
    {
        field: 'cdpStatus',
        headerName: 'CDP Status',
        description: '',
        sortable: false,
        editable: true,
        width: 60,
        hide: true
    },
    {
        field: 'status',
        // field: GRID_DETAIL_PANEL_TOGGLE_FIELD,
        headerName: 'Status',
        headerAlign: 'center',
        hide: cashState !== true,
        renderCell: (contracts) => {
            const rowCdpStatus = contracts.row.cdpStatus;
            return (<div onMouseOver={() => handleMousedRow(contracts.row)}
                         style={{
                             display: 'flex',
                             justifyContent: 'center',   // center horizontally
                             alignItems: 'center',       // center vertically
                             width: '100%',              // take full cell width
                             height: '100%',             // take full cell height
                         }}
                >
                    {/*// <MoreHorizIcon fontSize={'small'} onClick= {() => handleControls()}/>*/}
                    <WorkIssuanceStatusMenu rowCdpStatus={rowCdpStatus}/>
                </div>
            );
        }
    },
    {
        field: 'currentAmount',
        headerName: 'raw currentAmount',
        description: '',
        sortable: false,
        filterable: false,
        editable: true,
        align: 'right', // aligns cell content
        headerAlign: 'right', // optional: aligns header text too
        width: 80,
        hide: true
    },
    {
        field: 'dueDate',
        headerName: 'Due Date',
        description: '',
        sortable: false,
        filterable: false,
        editable: true,
        width: 100,
        hide: false
    },
    {
        field: 'displayCurrentAmount',
        headerName: cashState === true ? 'Current Owed' :
            accrualState === true ? 'Accrual Current Owed':
                liabilityState === true ? 'Liability Current Owed':
                ultimatesState === true ? 'Ultimate Current Owed' : 'Current Owed',
        description: '',
        sortable: false,
        filterable: false,
        editable: true,
        align: 'right', // aligns cell content
        headerAlign: 'right', // optional: aligns header text too
        width: 160,
        hide: false
    },
    {
        // field: 'mockIndicator',
        field: GRID_DETAIL_PANEL_TOGGLE_FIELD,
        type: 'actions',  // Required for built-in expand behavior
        headerName: 'Expression',
        renderCell: (contracts) =>
        {
            if((contracts.row.expression !== null) && (contracts.row.expression !== '')){
                return (
                    <Tooltip title={"Value comes from an expression.  Click to see."}>
                        <Avatar sx={{ height:20, width: 20, fontSize: 16, bgcolor: deepOrange[500] }}>e</Avatar>
                    </Tooltip>)}
            // if(contracts.row.mockIndicator=='m'){
            //     return (
            //         <Avatar sx={{ height:20, width: 20, fontSize: 16, bgcolor: deepPurple[500] }}>{contracts.row.mockIndicator} </Avatar>)}
        },
        description: '',
        sortable: false,
        width: 90,
    },
    {
        field: "more",
        headerName: '',
        width: 20,
        padding: 0,
        margin: 0,
        sortable: false,
        menu: false,
        filter: false,
        hide: true,
        renderCell: (contracts) => {
            const rowCdpStatus = contracts.row.cdpStatus;
            return (<div onMouseOver = {() => handleMousedRow(contracts.row)}  >
                    {/*// <MoreHorizIcon fontSize={'small'} onClick= {() => handleControls()}/>*/}
                    <WorkIssuanceStatusMenu rowCdpStatus = {rowCdpStatus}/>
                </div>
            );
        }

    },

    {
        field: 'itdOwedAmount',
        headerName: 'raw itdOwedAmount',
        description: '',
        sortable: false,
        filterable: false,
        editable: true,
        align: 'right', // aligns cell content
        headerAlign: 'right', // optional: aligns header text too
        width: 80,
        hide: true
    },
    {
        field: 'displayItdOwedAmount',
        headerName: cashState === true ? 'ITD Owed' :
            accrualState === true ? 'Accrual ITD Owed':
                liabilityState === true ? 'Liability ITD Owed':
                ultimatesState === true ? 'Ultimate ITD Owed' : 'ITD Owed',
        description: '',
        sortable: false,
        filterable: false,
        editable: true,
        align: 'right', // aligns cell content
        headerAlign: 'right', // optional: aligns header text too
        width: 160,
        hide: false
    },
    {
        field: 'paidBalanceAmount',
        headerName: 'raw paidBalanceAmount',
        description: '',
        sortable: false,
        filterable: false,
        editable: true,
        align: 'right', // aligns cell content
        headerAlign: 'right', // optional: aligns header text too
        width: 80,
        hide: true
    },
    {
        field: 'displayPaidBalanceAmount',
        headerName: 'Paid Balance',
        description: '',
        sortable: false,
        filterable: false,
        editable: true,
        align: 'right', // aligns cell content
        headerAlign: 'right', // optional: aligns header text too
        width: 120,
        hide: false
    },
    {
        field: 'offsetAmount',
        headerName: 'raw offsetAmount',
        description: '',
        sortable: false,
        filterable: false,
        editable: true,

        width: 80,
        hide: true
    },
    {
        field: 'displayOffsetAmount',
        headerName: 'Offset',
        description: '',
        sortable: false,
        filterable: false,
        editable: true,
        align: 'right', // aligns cell content
        headerAlign: 'right', // optional: aligns header text too
        width: 120,
        hide: false
    },
    {
        field: 'offsetHistoryAmount',
        headerName: 'raw offsetHistoryAmount',
        description: '',
        sortable: false,
        filterable: false,
        editable: true,
        width: 80,
        hide: true
    },
    {
        field: 'displayOffsetHistoryAmount',
        headerName: 'Offset History',
        description: '',
        sortable: false,
        filterable: false,
        editable: true,
        align: 'right', // aligns cell content
        headerAlign: 'right', // optional: aligns header text too
        width: 120,
        hide: false
    },
    {    field: 'contractId',
        headerName: 'Contract ID',
        description: '',
        sortable: true,
        width: 60,
        hide: true
    },
    {
        field: 'contractName',
        headerName: 'On Contract',
        description: '',
        sortable: false,
        filterable: false,
        editable: true,
        // editable: true,
        width: 350,
        hide: false
    },
    {
        field: 'dataType',
        headerName: 'dataType',
        description: '',
        sortable: false,
        editable: true,
        width: 100,
        hide: true
    },
    {
        field: 'sourceType',
        headerName: 'sourceType',
        description: '',
        sortable: false,
        editable: true,
        width: 100,
        hide: true
    },
    {
        field: 'dataPointRange',
        headerName: 'Range',
        description: '',
        sortable: false,
        editable: true,
        width: 80,
        hide: true
    },
    {
        field: 'cdpId',
        headerName: 'CDP ID',
        description: '',
        sortable: false,
        editable: true,
        width: 60,
        hide: true
    },
    {
        field: 'cdpvId',
        headerName: 'CDPV ID',
        description: '',
        sortable: false,
        editable: true,
        width: 60,
        hide: true
    },
    {
        field: 'iterationNumber',
        headerName: '#',
        description: '',
        sortable: false,
        editable: true,
        width: 15,
        hide: true
    },


    {
        field: 'hierarchyLevel',
        headerName: 'hierarchyLevel',
        description: '',
        sortable: false,
        editable: true,
        width: 20,
        hide: true
    },
    {
        field: 'hierarchyOrder',
        headerName: 'hierarchyOrder',
        description: '',
        sortable: false,
        editable: true,
        width: 20,
        hide: true
    },
    {
        field: 'hierarchy',
        headerName: 'Hierarchy',
        description: '',
        sortable: false,
        filterable: false,
        editable: true,
        width: 80,
        hide: true
    },

];

// *************** END COLUMNS *******************************